export const NoteSil = ({ className = "" }) => (
  <svg viewBox="0 0 40 48" className={className} fill="currentColor" aria-hidden="true">
    <path d="M24 4v28" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" fill="none" />
    <ellipse cx="17" cy="33" rx="8" ry="6" transform="rotate(-22 17 33)" />
    <path d="M24 4c8 3 12 8 11 16-3-5-6-7-11-7z" />
  </svg>
);

export const DoubleNoteSil = ({ className = "" }) => (
  <svg viewBox="0 0 56 48" className={className} fill="currentColor" aria-hidden="true">
    <path d="M16 10v26M46 6v26" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" fill="none" />
    <path d="M16 10L46 4v8L16 18z" />
    <ellipse cx="10" cy="37" rx="7.5" ry="5.5" transform="rotate(-22 10 37)" />
    <ellipse cx="40" cy="33" rx="7.5" ry="5.5" transform="rotate(-22 40 33)" />
  </svg>
);

export const StarSil = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M12 1.5l2.6 7.9 7.9 2.6-7.9 2.6L12 22.5l-2.6-7.9L1.5 12l7.9-2.6z" />
  </svg>
);

export const BookSil = ({ className = "" }) => (
  <svg viewBox="0 0 64 40" className={className} fill="currentColor" aria-hidden="true">
    <path d="M2 8q15-8 30 0v30Q17 30 2 38z" />
    <path d="M32 8q15-8 30 0v30q-15-8-30 0z" opacity=".82" />
  </svg>
);

export const FairySil = ({ className = "" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="currentColor" aria-hidden="true">
    <ellipse cx="20" cy="26" rx="13" ry="8" transform="rotate(-35 20 26)" opacity=".75" />
    <ellipse cx="22" cy="38" rx="9" ry="5" transform="rotate(20 22 38)" opacity=".6" />
    <circle cx="34" cy="16" r="5" />
    <path d="M34 22c-4 0-7 3-7 7l-4 20h22l-4-20c0-4-3-7-7-7z" />
    <path d="M39 26l13-12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M54 8l1.3 3.2 3.2 1.3-3.2 1.3L54 17l-1.3-3.2-3.2-1.3 3.2-1.3z" />
  </svg>
);

export function FloatingMotifs({ className = "" }) {
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden text-navy ${className}`} aria-hidden="true">
      <NoteSil className="motif-float absolute left-[4%] top-[14%] w-8 opacity-20" />
      <StarSil className="motif-twinkle absolute left-[38%] top-[6%] w-5 opacity-40" />
      <DoubleNoteSil className="motif-float absolute right-[6%] bottom-[18%] w-12 opacity-15 [animation-delay:1.2s]" />
      <StarSil className="motif-twinkle absolute right-[30%] top-[18%] w-3 [animation-delay:.8s]" />
      <StarSil className="motif-twinkle absolute left-[12%] bottom-[12%] w-4 [animation-delay:1.6s]" />
    </div>
  );
}
